import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { ClientErrorCodes, FeatureFlag, } from '@models';
import { ODataGridComponent, urlStateHandler, } from '@pages/generics/grid';
import { ProcessService } from '@services';
import { encodeParams } from '@utils/encode.utils';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, } from 'rxjs';
import { finalize, map, switchMap, } from 'rxjs/operators';
import { ProccessSettingsModalComponent, ProcessModalComponent, ProcessVersionsModalComponent, } from './modals';
var ɵ0 = urlStateHandler;
var ProcessesPageComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ProcessesPageComponent, _super);
    function ProcessesPageComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            processDetails$: new BehaviorSubject(false),
        };
        _this.updatingItems$ = new BehaviorSubject(false);
        _this.isMonitoringEnabled = _this._appState.settings.isFeatureEnabled(FeatureFlag.Monitoring);
        _this._processService = _this._service;
        return _this;
    }
    Object.defineProperty(ProcessesPageComponent.prototype, "isProcessSettingEnabled", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.MediaRecording) ||
                this._appState.settings.isFeatureEnabled(FeatureFlag.ProcessSettingAutoStart);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProcessesPageComponent.prototype, "isEveryProcessOutOfDate", {
        get: function () {
            return this._grid.selectionManager.selected
                .every(function (row) { return !row.isLatestVersion; });
        },
        enumerable: true,
        configurable: true
    });
    ProcessesPageComponent.prototype.ngOnInit = function () {
        this._expand$.next(['Environment', 'CurrentVersion']);
        this._select$.next([
            'Id',
            'IsLatestVersion',
            'IsProcessDeleted',
            'ProcessKey',
            'ProcessVersion',
            'Description',
            'Arguments',
            'Name',
        ]);
        this.isCurrentFolderClassic$ = this._appState.user.folder.isClassic$;
    };
    ProcessesPageComponent.prototype.openModal = function (model) {
        var _this = this;
        var clone;
        if (model) {
            clone = cloneDeep(model);
        }
        this._modal
            .openModal(ProcessModalComponent, clone)
            .afterClosedResult()
            .subscribe(function (res) {
            if (res.type === 1 /* Add */) {
                _this._refresh$.next();
            }
        });
    };
    ProcessesPageComponent.prototype.openVersionsModal = function (model) {
        var _this = this;
        this.loading.processDetails$.next(true);
        this._processService.getInstance(model.id, ['ReleaseVersions'])
            .pipe(finalize(function () { return _this.loading.processDetails$.next(false); }), map(function (data) {
            if (data.arguments && data.arguments.input) {
                data.arguments.input.forEach(function (inputArg) { return inputArg.source = inputArg.hasDefault ? 'package' : null; });
            }
            return data;
        }), switchMap(function (data) {
            return _this._modal
                .openModal(ProcessVersionsModalComponent, data)
                .afterClosedResult();
        }))
            .subscribe(function (res) {
            if (res.type === 2 /* Update */) {
                _this._refresh$.next();
            }
        });
    };
    ProcessesPageComponent.prototype.openProcessSettingsModal = function (model) {
        var _this = this;
        this.loading.processDetails$.next(true);
        this._processService.getInstance(model.id)
            .pipe(finalize(function () { return _this.loading.processDetails$.next(false); }), switchMap(function (data) {
            return _this._modal
                .openModal(ProccessSettingsModalComponent, data)
                .afterClosedResult();
        }))
            .subscribe();
    };
    ProcessesPageComponent.prototype.removeProcesses = function (items) {
        var _this = this;
        var itemsIds = (items || this._grid.selectionManager.selected)
            .map(function (p) { return p.id; });
        this._modal.onConfirm(null, function () {
            _this.loading$.next(true);
            itemsIds.forEach(function (id) {
                _this._processService.delete(id)
                    .subscribe(function () {
                    _this._refresh$.next();
                });
            });
        }, function () { }, this._translate.instant('processes_page_remove_message'));
    };
    ProcessesPageComponent.prototype.onBulkUpdateItems = function () {
        var _this = this;
        this.loading$.next(true);
        this._modal.onConfirm(null, function () {
            _this._processService
                .updateReleasesToLatestVersionBulk(_this._grid.selectionManager.selected.map(function (s) { return s.id; }))
                .pipe(finalize(function () {
                _this.loading$.next(false);
                _this._refresh$.next();
            }))
                .subscribe(function (response) {
                if (response.FailedItems && response.FailedItems.length) {
                    var message = _this._translate.instant('process_page_update_bulk_failed_message', {
                        numberOfProcesses: response.FailedItems.length,
                    });
                    _this._snack.error(message + " (#" + ClientErrorCodes.BulkUpdateProcessesFailed + ")");
                }
            });
        }, function () { return _this.loading$.next(false); }, this._translate.instant('processes_page_update_bulk_message'));
    };
    ProcessesPageComponent.prototype.getProcessTriggerParams = function (_a) {
        var id = _a.id, name = _a.name;
        return {
            process: encodeParams({ id: id, name: name }),
        };
    };
    return ProcessesPageComponent;
}(ODataGridComponent));
export { ProcessesPageComponent };
export { ɵ0 };
